import { render, staticRenderFns } from "./team_details.vue?vue&type=template&id=67e677a9&scoped=true&"
import script from "./team_details.vue?vue&type=script&lang=js&"
export * from "./team_details.vue?vue&type=script&lang=js&"
import style0 from "./team_details.vue?vue&type=style&index=0&id=67e677a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e677a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e677a9')) {
      api.createRecord('67e677a9', component.options)
    } else {
      api.reload('67e677a9', component.options)
    }
    module.hot.accept("./team_details.vue?vue&type=template&id=67e677a9&scoped=true&", function () {
      api.rerender('67e677a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/view-team/team_details.vue"
export default component.exports